import { Route, Routes, Navigate } from "react-router-dom";
import Tabs from "./_components/Tabs";
import RoleACLDataTable from "views/agent/collection/info-agent/acl/role/role-datatable/RoleACLDataTable";
import UserACLDataTable from "views/agent/collection/info-agent/acl/user/user-datatable";
import { ACLProvider } from "./_context/AgentACLContext";
const AgentACL = () => {
  return (
    <ACLProvider>
      <Tabs />
      <Routes>
        <Route path="/" element={<Navigate to="/roles" replace />} />
        <Route path="/roles" element={<RoleACLDataTable />} />
        <Route path="/users" element={<UserACLDataTable />} />
      </Routes>
    </ACLProvider>
  );
};

export default AgentACL;
